import CommunityWhiteHero from 'components/shared/CommunityWhiteHero'
import SliceManager from 'components/shared/SliceManager'
import PreviewBanner from 'components/shared/PreviewBanner'

import { getDataDependencies } from 'services/api'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'

const Community = ({ pageData: { communityHero, slices }, preview }) => {
  return (
    <>
      <div className="container">
        {preview && <PreviewBanner />}
        {communityHero && <CommunityWhiteHero {...communityHero} />}
        {slices && <SliceManager slices={slices} />}
      </div>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  try {
    const data = await fetchSingleType('community', preview)
    const extendedData = await getDataDependencies(data)

    return { props: { pageData: extendedData, preview } }
  } catch (error) {
    return { props: {} }
  }
}

export default Community
